/*
 * sidebar (config)
 */
import type { AuthUser, UserRole } from "@emr/types"
import { getUserRole } from "@emr/utils"
import {
	Calendar,
	Factory,
	FileText,
	FolderOpen,
	Info,
	LayoutDashboard,
	Scale,
	Shield,
	SquareTerminal,
	Stethoscope,
	User as UserIcon,
	Users,
} from "lucide-react"

export function getSidebarMenuList(
	user?: AuthUser | null,
	devMode?: boolean,
	_flags?: any,
): any[] {
	const role = getUserRole(user)

	const dashboardGroup = {
		groupLabel: "",
		menus: [
			{
				to: "/dashboard",
				label: "Dashboard",
				icon: LayoutDashboard,
			},
		],
	}

	const menuList = [
		dashboardGroup,
		getMainMenuList(role),
		getBottomMenuList(user, role, devMode),
	].filter((group) => group && group.menus.length > 0)

	return menuList
}

/*
 * main
 */
function getMainMenuList(role: UserRole | null) {
	const menus: any[] = []

	if (role === "patient") {
		menus.push({
			label: "My Profile",
			icon: UserIcon,
			to: "/patient/me",
		})
		menus.push({
			label: "Appointments",
			icon: Calendar,
			to: "/appointment",
		})
		menus.push({
			label: "Health Records",
			icon: FileText,
			to: "/health-record",
		})
	} else if (
		role === "practitioner" ||
		role === "nurse" ||
		role === "admin" ||
		role === "super_admin"
	) {
		menus.push({
			label: "Patients",
			icon: Users,
			to: "/patient",
		})
		menus.push({
			label: "Schedule",
			icon: Calendar,
			to: "/schedule",
		})
		menus.push({
			label: "Appointments",
			icon: Calendar,
			to: "/appointment",
		})
		menus.push({
			label: "Producers",
			icon: Factory,
			to: "/producer",
		})
	}

	if (menus.length === 0) return null

	return { groupLabel: "Services", menus }
}

/*
 * bottom
 */
function getBottomMenuList(
	user?: AuthUser | null,
	role?: UserRole | null,
	devMode?: boolean,
) {
	const settings: any = { groupLabel: "Settings", menus: [] }

	if (user) {
		settings.menus.push({
			to: "/auth/account",
			label: "Account",
			icon: UserIcon,
		})

		if (role === "admin" || role === "super_admin") {
			settings.menus.push({
				to: "/auth/admin",
				label: "Admin",
				icon: Shield,
			})
			settings.menus.push({
				to: "/auth/practitioners",
				label: "Practitioners",
				icon: Stethoscope,
			})
			settings.menus.push({
				to: "/auth/attachment-types",
				label: "Attachment Types",
				icon: FolderOpen,
			})
		}
	}

	if (devMode) {
		settings.menus.push({
			to: "/dev",
			label: "Dev",
			icon: SquareTerminal,
		})
	}

	settings.menus.push({
		to: "/legal",
		label: "Legal",
		icon: Scale,
	})

	settings.menus.push({
		to: "/about",
		label: "About",
		icon: Info,
	})

	return settings
}
